import { keepPreviousData, useQuery } from '@tanstack/react-query';
import { api } from 'lib/httpClient';
import { ApiResponse } from 'further-types/api';
import { Api } from 'further-types/collection-history';
import { QUERY_STALE_TIME_MS } from 'further-ui/config';

export function useCollectionHistoryEvents(
  params: Api.ListCollectionHistoryEventsRequestQuery,
) {
  return useQuery({
    queryKey: ['collection-history', params],
    queryFn: async () =>
      (
        await api.get<ApiResponse<Api.ListCollectionHistoryEventsResponseBody>>(
          '/collection-history/events',
          { params },
        )
      ).data.data,
    placeholderData: keepPreviousData,
    staleTime: QUERY_STALE_TIME_MS,
    enabled: !!params.collection,
    retry: 1,
  });
}

export function useGetCollectionNames() {
  return useQuery({
    queryKey: ['collection-history-collection-names'],
    queryFn: async () =>
      (
        await api.get<ApiResponse<Api.ListCollectionNamesResponseBody>>(
          '/collection-history/collection-names',
        )
      ).data.data,
    placeholderData: keepPreviousData,
    staleTime: QUERY_STALE_TIME_MS,
  });
}
